import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CustomDataGrid } from '../../../../components/CustomDataGrid';
import useToggle from '../../../../hooks/useToggle';
import FeatureLabelModal from '../FeatureLabelModal/FeatureLabelModal';
import { getFeatureDetailList } from '../../../../features';

export default function FeatureManagerTable(props) {
  const {
    rows,
    columns,
    permissions,
  } = props;

  const dispatch = useDispatch();
  const [open, setOpen] = useToggle();
  const [label, setLabel] = useState('');

  const handleClose = () => {
    setOpen();
  };

  const handleOnRowClick = (params) => {
    const { colDef } = params;
    if (colDef.isRowSelectable) {
      setOpen();
      setLabel(params.row.feature_name);
      dispatch(getFeatureDetailList(params.row.feature_id));
    }
  };

  return (
    <>
      <CustomDataGrid
        getRowId={(row) => row.feature_name + row.feature_name.length}
        rows={rows || []}
        columns={columns}
        onCellClick={(params) => handleOnRowClick(params)}
        rowsPerPageOptions={[20]}
        pageSize={20}
        footer
      />
      {open && (
        <FeatureLabelModal
          label={label}
          open={open}
          handleClose={handleClose}
          permissions={permissions}
        />
      )}
    </>

  );
}
